export default "__VITE_ASSET__BY70bY$H__"